import api from "./api";
import store from "../store";

export async function downloadData() {
    await api
        .get("popular_artists", {
            params: {
                breadth: 1,
                depth: 1
            },
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-type": "Application/json",
                Authorization: `Bearer ${store.state.accessToken}`
            }
        })
        .then(
            response => {
                store.commit("popular_artists", response.data);
            },
            error => {
                error.response.status;
            }
        );

    await api
        .get("artists", {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-type": "Application/json",
                Authorization: `Bearer ${store.state.accessToken}`
            }
        })
        .then(
            response => {
                store.commit("artists", response.data);
            },
            error => {
                error.response.status;
            }
        );
}
